module.exports = __webpack_public_path__ + "static/banner-11-47492b7a459bcf090a82e86d1275bf99.jpg";